import React from 'react';
import { Notification } from 'react-admin';
import { Footer, Header } from '@/components/Landing';

export default ({ children, className, loginBut = true }) => {
  return (
    <div
      className="flex flex-col relative h-screen overflow-auto flex-grow"
      id="home-layout">
      <Notification />
      <Header loginBut={loginBut} />
      <div className={`flex ${className}`}>{children}</div>
      <Footer />
    </div>
  );
};
